import 'react-app-polyfill/stable'
import 'core-js'
import '@coreui/coreui/dist/css/coreui.min.css'
import '@coreui/chartjs/dist/css/coreui-chartjs.min.css'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { Provider } from 'react-redux'
import store from './store'
import { IntlProvider } from 'react-intl'

import { messages } from './components/locales/messages'
import TokenService from './components/services/token.service'

const locale = TokenService.getLocale()

const root = createRoot(document.getElementById('root'))
root.render(
  <Provider store={store}>
    <IntlProvider locale={locale} messages={messages[locale]}>
      <App />
    </IntlProvider>
  </Provider>,
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
